//searchField styling
$(document).on( 'init.dt', function ( e, settings ) {
    var $context = $('.dataTables_filter'),
        $input = $('input', $context),
        $label = $('label', $context);

    $label.append('<span class="dataTables_buffer"></span>');
    $input.attr('placeholder', 'Поиск...')

    var $buffer = $label.find('.dataTables_buffer');
    $buffer.text($input.val());
    if ($buffer.width() == 0) {
        $input.width('auto');
    } else {
        $input.width($buffer.width());
    }

    $input.on('input change focus', function () {
        $buffer.text($input.val());
        if ($buffer.width() == 0) {
            $input.width('auto');
        } else {
            $input.width($buffer.width());
        }
    })
});
//table adaptive
$(document).on( 'init.dt', function () {
    $('.dataTable').each(function(){
        $(this).wrap('<div class="layout__content-table"></div>');
    });
});